import "./competition_billa_2024.scss"

const onReady = (fn) => {
  if (document.readyState !== "loading") {
    fn()
  } else {
    document.addEventListener("DOMContentLoaded", fn)
  }
}

/**
 * Funkčnosť odosielania formuláru cez Fetch API.
 */
const activateForm = () => {
  const form = document.getElementById("comp-registration-form")

  if (form !== null) {
    const registrationModal = document.getElementById("registration-modal")
    const jqueryRegistrationModal = $("#registration-modal")

    form.addEventListener("submit", (evt) => {
      evt.preventDefault()

      const formData = new FormData(form)
      formData.append(
        "receipt_datetime",
        `${formData.get("day")}.${formData.get("month")}.${formData.get(
          "year"
        )} ${formData.get("hour")}:${formData.get("minute")}:${formData.get(
          "second"
        )}`
      )

      if (formData.get("receipt_photo") === "") {
        formData.delete("receipt_photo")
      }

      fetch(form.action, { method: "post", body: formData })
        .then((response) => response.text())
        .then((body) => {
          registrationModal.innerHTML = body
          if (
            document.getElementById("comp-registration-form") !== null
          ) {
            // formulár sa aktivuje znovu, ak bol znovu zobrazený s chybovými hláškami
            activateForm()
          } else {
            // formulár bol úspešne zobrazený a v modali sa zobrazí "Už len jeden klik..."
            const anotherReceiptBtn = document.getElementById(
              "register-another-receipt"
            )
            if (anotherReceiptBtn !== null) {
              anotherReceiptBtn.addEventListener("click", (evt) => {
                evt.preventDefault()
                fetch(form.action, {
                  headers: {
                    "X-Component": "form",
                  },
                })
                  .then((response) => response.text())
                  .then((body) => {
                    registrationModal.innerHTML = body
                    activateForm()
                  })
              })
            }
          }
          jqueryRegistrationModal.scrollTop(0)
        })
        .catch((err) => console.error(err))
    })

    // zmena textu po výbere súboru
    document
      .getElementById("id_receipt_photo")
      .addEventListener("change", (evt) => {
        if (evt.target.files.length > 0) {
          document.getElementById("coop-upload-text").textContent =
            "Obrázok bol nahraný"
        }
      })
  }
}

onReady(() => {
  // zobrazenie modalu s potvrdením o zaradení do súťaže, ak je potrebný parameter
  // v search params url
  const urlSearchParams = new URLSearchParams(location.search)
  if (urlSearchParams.get("show_confirmation_modal") !== null) {
    $("#confirmation-modal").modal("show")
  }

  if (urlSearchParams.get("show_htc_modal") !== null) {
    $("#how-to-compete-modal").modal("show")
  }

  if (urlSearchParams.get("show_one_more_click_modal") !== null) {
    $("#one-more-click-modal").modal("show")
  }

  activateForm()
})
